export const getSorter = <T>(key: string) => {
  if (key === 'chargingPile') {
    return (a: T, b: T): number => {
      const valA = a[key]?.chargingPileID ?? '未綁定';
      const valB = b[key]?.chargingPileID ?? '未綁定';

      return valA.localeCompare(valB);
    };
  }

  if (key === 'house') {
    return (a: T, b: T): number => {
      return a[key].householdNumber.localeCompare(b[key].householdNumber);
    };
  }

  return (a: T, b: T): number => {
    const valA = a[key];
    const valB = b[key];

    const isANumber = /^\d+$/.test(valA);
    const isBNumber = /^\d+$/.test(valB);

    if (isANumber && isBNumber) {
      return parseInt(valA) - parseInt(valB);
    }

    return valA?.toString().localeCompare(valB?.toString());
  };
};
